/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */

export const SkillTypeDto = {
    Language: 'LANGUAGE',
    ProgrammingLanguage: 'PROGRAMMING_LANGUAGE',
    Tool: 'TOOL',
    SystemTechnologyMethodology: 'SYSTEM_TECHNOLOGY_METHODOLOGY'
} as const;

export type SkillTypeDto = typeof SkillTypeDto[keyof typeof SkillTypeDto];



